/**
 * Nome do documento vira nome de arquivo e parte da chave no S3.
 * Mantém letras (A–Z, a–z + Latin-1 / Latin Extended-A), números e espaço.
 */
const DOCUMENT_NAME_CHAR = /[A-Za-z0-9\s\u00C0-\u017F]/;

export function filterDocumentNameInput(value: string): string {
  if (value == null || value === "") return "";
  return Array.from(value)
    .filter((char) => DOCUMENT_NAME_CHAR.test(char))
    .join("");
}
